<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!filtersets.newGroup1.hidden"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup1.collapsible }">
                    <div *ngIf="!filtersets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">Filters</span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup1.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-owner" *ngIf="!filters.owner.hidden" 
                                  class="field-container standard {{filters.owner.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.owner.styles.style"
                                  [ngClass]="filters.owner.styles.classes">
                              <div class="label-container"
                                    title="{{filters.owner.label}}{{filters.owner.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.owner.label}}">{{filters.owner.label}}<span *ngIf="filters.owner.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <Owners-owners_dd_single 
                                  data-cy="selector"
                                  [type]="filters.owner.control.type"
                                  formControlName="owner"
                                  (displayTextChange)="filters.owner.control.displayText=$event"
                                  [placeholder]="filters.owner.control.placeholder"
                                  [styles]="filters.owner.control.styles"
                                [statusId]="$fields_owner_selector_inParams_statusId"
                                [projectId]="$fields_owner_selector_inParams_projectId"
                              >
                              </Owners-owners_dd_single>
                              <ng-container *ngIf="filters.owner.invalid">
                                <ng-container *ngFor="let error of filters.owner.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-project" *ngIf="!filters.project.hidden" 
                                  class="field-container standard {{filters.project.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.project.styles.style"
                                  [ngClass]="filters.project.styles.classes">
                              <div class="label-container"
                                    title="{{filters.project.label}}{{filters.project.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.project.label}}">{{filters.project.label}}<span *ngIf="filters.project.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <Owners-projects_dd_single 
                                  data-cy="selector"
                                  [type]="filters.project.control.type"
                                  formControlName="project"
                                  (displayTextChange)="filters.project.control.displayText=$event"
                                  [placeholder]="filters.project.control.placeholder"
                                  [styles]="filters.project.control.styles"
                                [statusId]="$fields_project_selector_inParams_statusId"
                                [ownerId]="$fields_project_selector_inParams_ownerId"
                              >
                              </Owners-projects_dd_single>
                              <ng-container *ngIf="filters.project.invalid">
                                <ng-container *ngFor="let error of filters.project.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-warehouses" *ngIf="!filters.warehouses.hidden" 
                                  class="field-container standard {{filters.warehouses.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.warehouses.styles.style"
                                  [ngClass]="filters.warehouses.styles.classes">
                              <div class="label-container"
                                    title="{{filters.warehouses.label}}{{filters.warehouses.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.warehouses.label}}">{{filters.warehouses.label}}<span *ngIf="filters.warehouses.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <Locations-warehouses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.warehouses.control.type"
                                  formControlName="warehouses"
                                  (displayTextChange)="filters.warehouses.control.displayText=$event"
                                  [placeholder]="filters.warehouses.control.placeholder"
                                  [styles]="filters.warehouses.control.styles"
                              >
                              </Locations-warehouses_dd_multi>
                              <ng-container *ngIf="filters.warehouses.invalid">
                                <ng-container *ngFor="let error of filters.warehouses.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-type" *ngIf="!filters.type.hidden" 
                                  class="field-container double {{filters.type.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.type.styles.style"
                                  [ngClass]="filters.type.styles.classes">
                              <div class="label-container"
                                    title="{{filters.type.label}}{{filters.type.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.type.label}}">{{filters.type.label}}<span *ngIf="filters.type.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <FootPrintPortalManager-inbound_outbound_appointment_types_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.type.control.type"
                                  formControlName="type"
                                  (displayTextChange)="filters.type.control.displayText=$event"
                                  [placeholder]="filters.type.control.placeholder"
                                  [styles]="filters.type.control.styles"
                              >
                              </FootPrintPortalManager-inbound_outbound_appointment_types_dd_multi>
                              <ng-container *ngIf="filters.type.invalid">
                                <ng-container *ngFor="let error of filters.type.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
                        </div>
                      </div>
                    </div>            </div>
          </div>
        </div>

        <div class="widgets">
          <div *ngIf="!widgets.order_total_received_order_count_by_date_widget.hidden" class="widget-container">
            <PurchaseOrders-order_total_received_order_count_by_date_widget
            #$widgets_order_total_received_order_count_by_date_widget 
              [date]="$widgets_order_total_received_order_count_by_date_widget_inParams_date"
              [ownerId]="$widgets_order_total_received_order_count_by_date_widget_inParams_ownerId"
              [projectId]="$widgets_order_total_received_order_count_by_date_widget_inParams_projectId"
              [warehouseId]="$widgets_order_total_received_order_count_by_date_widget_inParams_warehouseId"
            ($refreshEvent)="refresh(false, false, '$widgets_order_total_received_order_count_by_date_widget')"
            >
            </PurchaseOrders-order_total_received_order_count_by_date_widget>
          </div>
          <div *ngIf="!widgets.order_total_picked_order_count_by_date_widget.hidden" class="widget-container">
            <SalesOrders-order_total_picked_order_count_by_date_widget
            #$widgets_order_total_picked_order_count_by_date_widget 
              [date]="$widgets_order_total_picked_order_count_by_date_widget_inParams_date"
              [ownerId]="$widgets_order_total_picked_order_count_by_date_widget_inParams_ownerId"
              [projectId]="$widgets_order_total_picked_order_count_by_date_widget_inParams_projectId"
              [warehouseId]="$widgets_order_total_picked_order_count_by_date_widget_inParams_warehouseId"
            ($refreshEvent)="refresh(false, false, '$widgets_order_total_picked_order_count_by_date_widget')"
            >
            </SalesOrders-order_total_picked_order_count_by_date_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="!tabs.dock_appointment_dashboard.hidden" class="tab" data-cy="tab-dock_appointment_dashboard">
              <h2 [className]="tabs.dock_appointment_dashboard.active? 'active': ''" (click)="tabs.dock_appointment_dashboard.activate()">{{tabs.dock_appointment_dashboard.title}}</h2>
            </div>
          </div>
        
              <FootPrintPortalManager-orders_dashboard_grid *ngIf="tabs.dock_appointment_dashboard.active"
              #$tabs_dock_appointment_dashboard
              [ownerId]="$tabs_dock_appointment_dashboard_orders_dashboard_grid_inParams_ownerId"
              [projectId]="$tabs_dock_appointment_dashboard_orders_dashboard_grid_inParams_projectId"
              [warehouseIds]="$tabs_dock_appointment_dashboard_orders_dashboard_grid_inParams_warehouseIds"
              [typeIds]="$tabs_dock_appointment_dashboard_orders_dashboard_grid_inParams_typeIds"
              [fromDate]="$tabs_dock_appointment_dashboard_orders_dashboard_grid_inParams_fromDate"
              [toDate]="$tabs_dock_appointment_dashboard_orders_dashboard_grid_inParams_toDate"
              ($refreshEvent)="refresh(false, false, '$tabs_dock_appointment_dashboard')">
              </FootPrintPortalManager-orders_dashboard_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>